import { yearGroupOptionsPupils } from "@/constants/yearGroupOptions";

export default function validateContentToExport(content) {
  return new Promise((resolve) => {
    const valid = {
      groepen: { jaargroep: [] },
      leerlingen: { jaargroep: [] },
      leerkrachten: { email: [] },
    };

    //check if all teachers have email addresses filled
    content.leerkrachten.leerkracht.forEach((teacher) => {
      if (!teacher.emailadres) {
        valid.leerkrachten.email.push(false);
      }
    });

    //check if pupil yeargroup contains incorrect values
    const options = [];
    yearGroupOptionsPupils.forEach((option) => {
      options.push(String(option.naam));
    });

    content.leerlingen.leerling.forEach((pupil) => {
      if (!options.includes(String(pupil.jaargroep.naam))) {
        valid.leerlingen.jaargroep.push(pupil);
      }
    });

    //check if groups have yeargroup defined
    content.groepen.groep.forEach((group) => {
      if (group.jaargroep.key === undefined) {
        valid.groepen.jaargroep.push(group);
      }
    });

    resolve(valid);
  });
}
